module.exports = __webpack_public_path__ + "static/media/step6.d994fb98.png";